import { HttpClient } from '@angular/common/http';
import { Component, inject, type OnDestroy, type OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import type {
  ReqBody,
  ReqParams,
  ResBody,
} from '../../../server/routes/spaces/post';
import {
  generatePath,
  orgNameMaxLength,
} from '../../../server/services/utils.service';
import { AuthUserService } from '../auth-user.service';

@Component({
  selector: 'app-space-create-dialog',
  templateUrl: './space-create-dialog.component.html',
  styleUrls: ['./space-create-dialog.component.scss'],
  standalone: false,
})
export class SpaceCreateDialogComponent implements OnInit, OnDestroy {
  private dialogRef = inject(MatDialogRef<SpaceCreateDialogComponent>);
  private readonly data: { orgId: string } = inject(MAT_DIALOG_DATA);
  private authUserService = inject(AuthUserService);
  private router = inject(Router);
  private snackBar = inject(MatSnackBar);
  private http = inject(HttpClient);

  orgId: string;

  currentTitle: string;
  proposedTitle: string;

  form: FormGroup<{ name: FormControl<string> }>;
  subscriptions = new Subscription();

  constructor() {
    this.orgId = this.data.orgId;
  }

  ngOnInit(): void {
    this.form = new FormGroup({
      name: new FormControl('', {
        validators: [
          Validators.required,
          Validators.maxLength(orgNameMaxLength),
        ],
        nonNullable: true,
      }),
    });

    const nameSubscription = this.form.controls.name.valueChanges.subscribe(
      (value: string) => {
        const name = value.trim();
        // TODO: compare name to other space names
      }
    );
    this.subscriptions.add(nameSubscription);
  }

  createSpace(): void {
    const uncleanName = this.form.controls.name.value;
    const name = uncleanName.trim();
    // Set as error if space name exists already
    // Wait until the message is accepted before closing the dialog

    const { orgId } = this;
    const path = generatePath<ReqParams>('/api/orgs/:orgId/spaces', { orgId });

    const body: ReqBody = { name };

    const subscription = this.http.post<ResBody>(path, body).subscribe({
      next: ({ org, spaceId }) => {
        this.authUserService.updateOrg({ org });
        this.closeDialog();
        this.router.navigate(['/org', org._id, 'space', spaceId, 'edit']);
      },
      error: (err) => {
        this.snackBar.open('ERROR: could not create space.', 'Dismiss', {
          duration: 5000,
        });
        this.closeDialog();
      },
    });
    this.subscriptions.add(subscription);
  }

  closeDialog(): void {
    this.dialogRef.close('Create space dialog closed');
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
